import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ServiceCardComponent} from './service-card.component';
import {SharedModule} from '../../../shared/shared.module';
import {IconsModule} from '../../../icons/icons.module';
import {MatMenuModule} from '@angular/material/menu';
import {MatDividerModule} from '@angular/material/divider';


@NgModule({
  declarations: [
    ServiceCardComponent
  ],
  exports: [
    ServiceCardComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    IconsModule,
    MatMenuModule,
    MatDividerModule
  ]
})
export class ServiceCardModule {
}
